import React from 'react';

export const BookSevaContext = React.createContext();
